var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Spacer',{staticClass:"typo--m",attrs:{"bottom":"xs"}},[_vm._v(" "+_vm._s(_vm.$labels[_vm.data.value])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }